/**
 * useUpdateEmployee — React Query mutation HR dolgozó adatainak módosításához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateEmployee, type Employee, type UpdateEmployeeInput } from '../api/hr-api';
import { employeeQueryKey } from './useEmployee';
import { employeesQueryKey } from './useEmployees';

interface UpdateEmployeeVariables {
  id: string;
  data: UpdateEmployeeInput;
}

export function useUpdateEmployee() {
  const queryClient = useQueryClient();

  return useMutation<Employee, Error, UpdateEmployeeVariables>({
    mutationFn: async ({ id, data }: UpdateEmployeeVariables) => {
      const res = await updateEmployee(id, data);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: employeesQueryKey });
      void queryClient.invalidateQueries({ queryKey: employeeQueryKey(variables.id) });
    },
  });
}
